export const calculateTotalAdded = (
  sources: {
    added: number;
    id: string;
    removed: number;
  }[],
): number => {
  return sources.reduce((totalAdded, source) => totalAdded + source.added, 0);
};

export const calculateTotalRemoved = (
  sources: {
    added: number;
    id: string;
    removed: number;
  }[],
): number => {
  return sources.reduce((totalRemoved, source) => totalRemoved + source.removed, 0);
};
